<template>
    <ClModal
        v-if="showDialog"
        v-model="showDialog"
        :persistent="dialog.persistent"
        :width="dialog.width"
    >
        <v-card>
            <!-- Dialog Header -->
            <v-card-title
                :class="dialog.type"
                class="white--text"
            >
                <h3>{{ dialog.title }}</h3>
                <v-spacer />
                <v-btn
                    icon
                    @click="closeHandler()"
                >
                    <v-icon color="white">mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <!-- Dialog Body -->
            <v-card-text class="modal-text">
                {{ dialog.message }}
            </v-card-text>
            <!-- Dialog Buttons -->
            <v-card-actions>
                <v-spacer/>
                <!-- Cancel Button -->
                <ClButton
                    v-if="dialog.cancelText"
                    type="secondary"
                    :rounded="false"
                    @click="cancelHandler()"
                >
                    {{ dialog.cancelText }}
                </ClButton>
                <!-- Confirm Button -->
                <ClButton
                    :color="dialog.type"
                    :rounded="false"
                    @click="confirmHandler()"
                >
                    {{ dialog.confirmText }}
                </ClButton>
            </v-card-actions>
        </v-card>
    </ClModal>
</template>

<script>
// Vuex
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'GlobalDialog',
    computed: {
        ...mapGetters( {
            hasDialog: 'hasDialog',
        } ),
        ...mapState( {
            dialog: ( state ) => state.dialog,
            closable: ( state ) => state.dialog.closable,
        } ),
        showDialog: {
            get() {
                return this.hasDialog;
            },
            set() {
                this.dismissDialog();
            },
        },
    },
    methods: {
        closable: true,
        dismissDialog() {
            this.$store.dispatch( 'clearDialog' );
        },
        closeHandler() {
            if ( this.dialog.closable ) {
                this.dialog.closable();
            }
            this.dismissDialog();
        },
        cancelHandler() {
            if ( this.dialog.onCancel ) {
                this.dialog.onCancel();
            }
            this.dismissDialog();
        },
        confirmHandler() {
            if ( this.dialog.onConfirm ) {
                this.dialog.onConfirm();
            }
            this.dismissDialog();
        },
    },
};
</script>

<style scoped lang="scss">
.modal-text {
    margin-top: 1rem;
}
.v-dialog>.v-card>.v-card__actions {
    padding-bottom: 1rem;
}
</style>
